import type { Store } from 'vuex'
import type { ContextProvider } from './interfaces/context.provider'
import { interfaces } from 'inversify'
import { TYPES } from '../config/inversify.types'
import { CONTEXT_CONSTS } from '../store/context/context.consts'
import Context = interfaces.Context

/**
 * Function to inject a {@link ContextState} using InversifyJS. The provider injected takes the
 * context from the Vuex store, from the `'epb-context'` module.
 *
 * @param context - The InversifyJS context, which includes the container. This is used to get the
 * Vuex Store.
 *
 * @remarks This function needs the InversifyJS context, then it needs to be bound to container
 * using `toDynamicValue`:
 * `CONTAINER.bind(TYPES.ContextProvider).toDynamicValue(getStoreContextProvider);`.
 */
export function getStoreContextProvider({ container }: Context): ContextProvider {
  return (useCurrentFeatureContext = true) => {
    const store = container.get<Store<any>>(TYPES.Store)
    if (useCurrentFeatureContext) {
      return store.getters[`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.getters.context}`]
    }

    return store.getters[`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.getters.baseContext}`]
  }
}
